<template lang="">
  <div>
    <header>
      <div class="header_box">
        <div class="header_content">
          <img src="@/assets/img/logo.png" />
          <div class="header_center">
            <div
              class="header_list"
              :class="$store.getters.GetStatus == 1 ? 'active' : ''"
              @click="ChangeRouter('/')"
            >
              Home
            </div>
            <div
              class="header_list header_list_center"
              :class="$store.getters.GetStatus == 2 ? 'active' : ''"
              @click="ChangeRouter('/proposition')"
            >
              Value Proposition
            </div>
            <div
              class="header_list"
              :class="$store.getters.GetStatus == 3 ? 'active' : ''"
              @click="ChangeRouter('/product')"
            >
              Product
            </div>
          </div>
          <div class="header_right">
            <div class="header_right_l">Login/Signup</div>
            <div class="header_right_r">EN</div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    ChangeRouter(url) {
      this.$router.push(url);
      // this.GoTop();
    },
    GoTop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  height: 80px;
  .header_box {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    height: 80px;
    background: #28283c;
    z-index: 1000;
    .header_content {
      width: 1200px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      img {
        width: 64px;
        height: 40px;
        padding: 20px 0;
        cursor: pointer;
      }
      .header_center {
        .header_list {
          display: inline-block;
          vertical-align: top;
          font-family: "ob";
          font-size: 18px;
          color: #fff;
          line-height: 80px;
          cursor: pointer;
          position: relative;
          &.header_list_center {
            margin: 0 60px;
          }
          &.active {
            color: #f43d3d;
            &::before {
              content: " ";
              position: absolute;
              width: 100%;
              height: 8px;
              background-color: #f43d3d;
              left: 0;
              bottom: 0;
            }
          }
        }
      }
      .header_right {
        .header_right_l {
          display: inline-block;
          font-family: "ob";
          font-size: 20px;
          color: #fff;
          line-height: 80px;
          cursor: pointer;
        }
        .header_right_r {
          display: inline-block;
          font-family: "oh";
          font-size: 20px;
          color: #fff;
          line-height: 80px;
          margin-left: 24px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
